import { render } from "./CpsOverviewItemAbstract.vue?vue&type=template&id=76a53c80&ts=true"
import script from "./CpsOverviewItemAbstract.vue?vue&type=script&lang=ts"
export * from "./CpsOverviewItemAbstract.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__